export function getAppid() {
  const currentUrl = window.location.href
  let arr = currentUrl.split('?')
  if (arr.length > 1) {
    arr = arr[1].split('&')
    for (let i = 0; i < arr.length; i++) {
      const tem = arr[i].split('=')
      if (tem[0] === 'id') {
        return tem[1]
      }
    }
    return ''
  } else {
    return ''
  }
}
